import React, { useState, useEffect } from "react";
import CreateJobsModal from "../../components/admin/Jobs/CreateJobsModal";
import axios from "axios"; // Import axios
import EditJobModal from "../../components/admin/Jobs/EditJobsModal";
import { MdDeleteSweep } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { PDFDocument, rgb } from "pdf-lib";
import CoverLetterModal from "../../components/Modals/CoverLetterModal";
import * as XLSX from "xlsx";

const AdminJobs = () => {
  const [activeTab, setActiveTab] = useState("viewJobs");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [jobs, setJobs] = useState([]); // State for storing jobs data
  const [loading, setLoading] = useState(true); // State for loading status
  const [error, setError] = useState(""); // State for error messages
  const [isOpenEditModal, setIsOpenEditModal] = useState(false);
  const [selectedJob, setSelectedJob] = useState({});
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [appliedJobs, setAppliedJobs] = useState([]);
  const [isModalOpenCoverLetter, setIsModalOpenCoverLetter] = useState(false);

  const handleDownloadAppliedJobs = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(appliedJobs.map((job, index) => ({
      'SL NO': index + 1,
      'Candidate Name': job.candidate_name,
      'Email': job.email,
      'Phone': job.phone,
      'Current Location': job.current_location,
      'Experience': job.experience,
      'Cover Letter': job.cover_letter,
      'Resume': job.resume
    })));
  
    // Set column widths
    ws['!cols'] = [
      { wch: 10 },  // SL NO
      { wch: 30 },  // Candidate Name
      { wch: 30 },  // Email
      { wch: 20 },  // Phone
      { wch: 30 },  // Current Location
      { wch: 20 },  // Experience
      { wch: 50 },  // Cover Letter
      { wch: 30 },  // Resume
    ];
  
    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Applied Jobs');
  
    // Write to file
    XLSX.writeFile(wb, 'Applied_Jobs.xlsx');
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const openModal = () => {
    setIsModalOpenCoverLetter(true);
  };

  const closeModal = () => {
    setIsModalOpenCoverLetter(false);
  };
  const openEditModal = (job) => {
    setSelectedJob(job);
    setIsOpenEditModal(true);
  };

  const closeEditModal = () => {
    setIsOpenEditModal(false);
  };

  const fetchJobs = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_KEY}/jobs/get-all-jobs`
      );
      setJobs(response?.data?.jobs); // Update state with fetched data
      if (response.data.length === 0) {
        setError("Data not found");
      }
    } catch (error) {
      console.error("Error fetching jobs data:", error);
      setError("Error fetching data");
    } finally {
      setLoading(false);
    }
  };

  const fetchAppliedJobs = () => {
    setLoading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_KEY}/applied-jobs/get-all-applied-jobs`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response?.data?.appliedJobs);
        setAppliedJobs(response?.data?.appliedJobs);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setError(error);
        setLoading(false);
      });
  };

  // Fetch jobs data on component mount
  useEffect(() => {
    fetchJobs();
    fetchAppliedJobs();
  }, []);

  // Handle job deletion
  const handleDelete = async (id) => {
    setDeleteLoading(id);
    try {
      await axios.delete(`${process.env.REACT_APP_API_KEY}/jobs/delete/${id}`);
      setJobs((prevJobs) => prevJobs.filter((job) => job._id !== id));
      setDeleteLoading(false);
    } catch (error) {
      setDeleteLoading(false);
      console.error("Error deleting job:", error);
    }
  };

  const openModalCoverLetter = (job) => {
    setSelectedJob(job);
    setIsModalOpenCoverLetter(true);
  };

  const closeModalCoverLetter = () => {
    setIsModalOpenCoverLetter(false);
    setSelectedJob({});
  };

  const handleDeleteApplyJobs = (id) => {
    setDeleteLoading(id);
    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_KEY}/applied-jobs/delete/${id}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response.data);
        fetchAppliedJobs();
        setDeleteLoading(null);
      })
      .catch((error) => {
        console.log(error);
        setDeleteLoading(null);
      });
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <div className="flex space-x-4 border border-purple-400">
          <button
            onClick={() => handleTabChange("viewJobs")}
            className={`py-2 px-4 ${
              activeTab === "viewJobs" ? "bg-customPurple text-white" : ""
            }`}
          >
            All Jobs
          </button>
          <button
            onClick={() => handleTabChange("appliedJobs")}
            className={`py-2 px-4 ${
              activeTab === "appliedJobs" ? "bg-customPurple text-white" : ""
            }`}
          >
            Applied Jobs
          </button>
        </div>
        <button
          onClick={openModal}
          className="bg-customPurple rounded-lg px-4 py-2 font-semibold text-white"
        >
          Create Job
        </button>
      </div>

      <div className="w-full overflow-x-scroll">
        {activeTab === "viewJobs" && (
          <div>
            {loading ? (
              <div className="animate-pulse">
                <div className="bg-gray-200 h-6 w-1/4 mb-4"></div>
                <div className="bg-gray-200 h-4 w-full mb-2"></div>
                <div className="bg-gray-200 h-4 w-full mb-2"></div>
                {/* Add more skeleton loaders as needed */}
              </div>
            ) : error ? (
              <p className="text-red-500">{error}</p>
            ) : jobs.length === 0 ? (
              <p className="text-gray-500">No jobs available</p>
            ) : (
              <>
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                  <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-customPurple dark:text-customWhite">
                    <tr>
                      <th scope="col" className="p-4">
                        SL NO
                      </th>
                      <th scope="col" className="px-6 py-3">
                        JOB TITLE
                      </th>
                      <th scope="col" className="px-6 py-3">
                        JOB TYPE
                      </th>
                      <th scope="col" className="px-6 py-3">
                        SALARY
                      </th>
                      <th scope="col" className="px-6 py-3">
                        JOB POSTED DATE
                      </th>
                      <th scope="col" className="px-6 py-3">
                        JOB EXPIRE DATE
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {jobs.map((job, index) => (
                      <tr
                        key={job._id}
                        className="bg-white border-b border-gray-300 hover:bg-violet-200"
                      >
                        <th
                          scope="row"
                          className="px-6 py-4 font-medium whitespace-nowrap"
                        >
                          {index + 1}
                        </th>
                        <td className="px-6 py-4">{job.job_title}</td>
                        <td className="px-6 py-4">{job.job_type}</td>
                        <td className="px-6 py-4">{job.salary}</td>
                        <td className="px-6 py-4">{job.job_posted_date}</td>
                        <td className="px-6 py-4">{job.job_expire_date}</td>
                        <td className="flex items-center px-6 py-4">
                          <button
                            onClick={() => openEditModal(job)}
                            className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                          >
                            <FaEdit size={16} />
                          </button>
                          <button
                            onClick={() => handleDelete(job._id)}
                            className="font-medium text-red-600 dark:text-red-500 hover:underline ms-3"
                            disabled={deleteLoading === job._id} // Disable button when loading
                          >
                            {deleteLoading === job._id ? ( // Show spinner only for the specific job
                              <div role="status">
                                <svg
                                  aria-hidden="true"
                                  className="inline w-4 h-4 text-gray-200 animate-spin dark:text-gray-600 fill-red-500"
                                  viewBox="0 0 100 101"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                    fill="currentFill"
                                  />
                                </svg>
                                <span className="sr-only">Loading...</span>
                              </div>
                            ) : (
                              <MdDeleteSweep size={20} />
                            )}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}
          </div>
        )}
       {activeTab === "appliedJobs" && (
  <div>
    <div className="flex md:justify-end">

    <button
      onClick={handleDownloadAppliedJobs}
      className="mb-4 px-4 py-2 bg-customPurple text-white rounded text-right"
      >
      Download Applied Jobs as Excel
    </button>
      </div>

    {loading ? (
      <div className="animate-pulse">
        <div className="bg-gray-200 h-6 w-1/4 mb-4"></div>
        <div className="bg-gray-200 h-4 w-full mb-2"></div>
        <div className="bg-gray-200 h-4 w-full mb-2"></div>
        {/* Add more skeleton loaders as needed */}
      </div>
    ) : error ? (
      <p className="text-red-500">{error}</p>
    ) : appliedJobs?.length === 0 ? (
      <p className="text-gray-500">Applied Jobs Not Found</p>
    ) : (
      <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-customPurple dark:text-customWhite">
          <tr>
            <th scope="col" className="p-4">SL NO</th>
            <th scope="col" className="px-6 py-3">Candidate Name</th>
            <th scope="col" className="px-6 py-3">Email</th>
            <th scope="col" className="px-6 py-3">Phone</th>
            <th scope="col" className="px-6 py-3">Current Location</th>
            <th scope="col" className="px-6 py-3">Experience</th>
            <th scope="col" className="px-6 py-3">Cover Letter</th>
            <th scope="col" className="px-6 py-3">Resume</th>
            <th scope="col" className="px-6 py-3">Action</th>
          </tr>
        </thead>
        <tbody>
          {appliedJobs.map((job, index) => (
            <tr key={job._id} className="bg-white border-b border-gray-300 hover:bg-violet-200">
              <th scope="row" className="px-6 py-4 font-medium whitespace-nowrap">{index + 1}</th>
              <td className="px-6 py-4">{job.candidate_name}</td>
              <td className="px-6 py-4">{job.email}</td>
              <td className="px-6 py-4">{job.phone}</td>
              <td className="px-6 py-4">{job.current_location}</td>
              <td className="px-6 py-4">{job.experience}</td>
              <td className="px-6 py-4">
                <button
                  onClick={() => openModalCoverLetter(job)}
                  className="text-blue-500 underline"
                >
                  See Cover Letter
                </button>
              </td>
              <td className="px-6 py-4">
                <a
                  href={job.resume}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 underline"
                >
                  View Resume
                </a>
              </td>
              <td className="flex items-center px-6 py-4">
                <button
                  onClick={() => handleDeleteApplyJobs(job._id)}
                  className="font-medium text-red-600 dark:text-red-500 hover:underline"
                  disabled={deleteLoading === job._id}
                >
                  {deleteLoading === job._id ? (
                    <div role="status">
                      <svg
                        aria-hidden="true"
                        className="inline w-4 h-4 text-gray-200 animate-spin dark:text-gray-600 fill-red-500"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                      </svg>
                      <span className="sr-only">Loading...</span>
                    </div>
                  ) : (
                    <MdDeleteSweep size={20} />
                  )}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </div>
)}

      </div>

      {isModalOpen && <CreateJobsModal onClose={closeModal} />}
      {isOpenEditModal && (
        <EditJobModal
          onClose={closeEditModal}
          selectedJob={selectedJob}
          fetchJobs={fetchJobs}
        />
      )}
      <CoverLetterModal
        isOpen={isModalOpenCoverLetter}
        onClose={closeModalCoverLetter}
        selectedJob={selectedJob}
      />
    </div>
  );
};

export default AdminJobs;
